import Fetch from 'utils/fetch';
import { generateQueryParams } from 'utils/custom-functions';

export const updatePendingVolumes = (body) => (
  Fetch.post('volume-orders:update-pending-volumes', body)
);

export const cancelVolumeOrder = (id, body) => (
  Fetch.post(`volume-orders/${id}:cancel`, body)
);

export const exportNegotiationVolumes = (params = {}) => {
  const { _page, _size, ...exportFilter } = params;

  return Fetch.get(`volume-orders/export:volume-order-in-negotiation?${generateQueryParams(exportFilter)}`)
    .then(({ data }) => data)
}

export const importNegotiationVolumes = (body) => (
  Fetch.post('volume-orders/import:volume-order-in-negotiation', body)
);
